'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var queue = require('async/queue');

var promiseToCallback = require('promise-to-callback');

var WorkerQueue = /*#__PURE__*/function () {
  /**
   * Creates a new WorkerQueue.
   *
   * @param {DHT} dht
   * @param {Run} run
   * @param {Object} path
   * @param {function} log
   */
  function WorkerQueue(dht, run, path, log) {
    _classCallCheck(this, WorkerQueue);

    this.dht = dht;
    this.run = run;
    this.path = path;
    this.log = log;
    this.concurrency = this.dht.concurrency;
    this.queue = this.setupQueue(); // a container for resolve/reject functions that will be populated
    // when execute() is called

    this.execution = null;
  }
  /**
   * Create the underlying async queue.
   *
   * @returns {Object}
   */


  _createClass(WorkerQueue, [{
    key: "setupQueue",
    value: function setupQueue() {
      var _this = this;

      var q = queue(function (peer, cb) {
        promiseToCallback(_this.processNext(peer))(cb);
      }, this.concurrency); // If there's an error, stop the worker

      q.error = function (err) {
        _this.log.error('queue', err);

        _this.stop(err);
      }; // When all peers in the queue have been processed, stop the worker


      q.drain = function () {
        _this.log('queue:drain');

        _this.stop();
      }; // When a space opens up in the queue, add some more peers


      q.unsaturated = function () {
        if (_this.running) {
          _this.fill();
        }
      };

      q.buffer = 0;
      return q;
    }
    /**
     * Stop the worker, optionally providing an error to pass to the worker's
     * callback.
     *
     * @param {Error} err
     */

  }, {
    key: "stop",
    value: function stop(err) {
      if (!this.running) {
        return;
      }

      this.running = false;
      this.queue.kill();
      this.log('worker:stop, %d workers still running', this.run.workers.filter(function (w) {
        return w.running;
      }).length);

      if (err) {
        this.execution.reject(err);
      } else {
        this.execution.resolve();
      }
    }
    /**
     * Use the queue from async to keep `concurrency` amount items running
     * per path.
     *
     * @return {Promise<void>}
     */

  }, {
    key: "execute",
    value: function () {
      var _execute = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var execPromise;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.running = true; // store the promise resolution functions to be resolved at end of queue

                this.execution = {};
                execPromise = new Promise(function (resolve, reject) {
                  return Object.assign(_this2.execution, {
                    resolve: resolve,
                    reject: reject
                  });
                }); // start queue

                this.fill(); // await completion

                _context.next = 6;
                return execPromise;

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function execute() {
        return _execute.apply(this, arguments);
      }

      return execute;
    }()
    /**
     * Add peers to the worker queue until there are enough to satisfy the
     * worker queue concurrency.
     * Note that we don't want to take any more than those required to satisfy
     * concurrency from the peers-to-query queue, because we always want to
     * query the closest peers to the key first, and new peers are continously
     * being added to the peers-to-query queue.
     */

  }, {
    key: "fill",
    value: function fill() {
      // Note:
      // - queue.running(): number of items that are currently running
      // - queue.length(): the number of items that are waiting to be run
      while (this.queue.running() + this.queue.length() < this.concurrency && this.path.peersToQuery.length > 0) {
        this.queue.push(this.path.peersToQuery.dequeue());
      }
    }
    /**
     * Process the next peer in the queue
     *
     * @param {PeerId} peer
     * @returns {Promise<void>}
     */

  }, {
    key: "processNext",
    value: function () {
      var _processNext = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(peer) {
        var continueQuerying, continueQueryingError, state, execError;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.running) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                if (!this.run.peersSeen.has(peer.toB58String())) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return");

              case 4:
                _context2.prev = 4;
                _context2.next = 7;
                return this.run.continueQuerying(this);

              case 7:
                continueQuerying = _context2.sent;
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](4);
                continueQueryingError = _context2.t0;

              case 13:
                if (this.running) {
                  _context2.next = 15;
                  break;
                }

                return _context2.abrupt("return");

              case 15:
                if (!continueQueryingError) {
                  _context2.next = 17;
                  break;
                }

                throw continueQueryingError;

              case 17:
                if (continueQuerying) {
                  _context2.next = 20;
                  break;
                }

                this.stop();
                return _context2.abrupt("return");

              case 20:
                if (!this.run.peersSeen.has(peer.toB58String())) {
                  _context2.next = 22;
                  break;
                }

                return _context2.abrupt("return");

              case 22:
                this.run.peersSeen.add(peer.toB58String()); // Execute the query on the next peer

                this.log('queue:work');
                _context2.prev = 24;
                _context2.next = 27;
                return this.execQuery(peer);

              case 27:
                state = _context2.sent;
                _context2.next = 33;
                break;

              case 30:
                _context2.prev = 30;
                _context2.t1 = _context2["catch"](24);
                execError = _context2.t1;

              case 33:
                if (this.running) {
                  _context2.next = 35;
                  break;
                }

                return _context2.abrupt("return");

              case 35:
                this.log('queue:work:done', execError, state);

                if (!execError) {
                  _context2.next = 38;
                  break;
                }

                throw execError;

              case 38:
                if (!(state && state.queryComplete)) {
                  _context2.next = 42;
                  break;
                }

                this.log('query:complete');
                this.run.stop();
                return _context2.abrupt("return");

              case 42:
                // If path is complete, just stop this worker.
                // Note: this.stop() kills the queue and resolves execution
                if (state && state.pathComplete) {
                  this.stop();
                }

              case 43:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 10], [24, 30]]);
      }));

      function processNext(_x) {
        return _processNext.apply(this, arguments);
      }

      return processNext;
    }()
    /**
     * Execute a query on the next peer.
     *
     * @param {PeerId} peer
     * @returns {Promise<void>}
     * @private
     */

  }, {
    key: "execQuery",
    value: function () {
      var _execQuery = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(peer) {
        var _this3 = this;

        var res, queryError;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return this.path.queryFunc(peer);

              case 3:
                res = _context4.sent;
                _context4.next = 9;
                break;

              case 6:
                _context4.prev = 6;
                _context4.t0 = _context4["catch"](0);
                queryError = _context4.t0;

              case 9:
                if (this.running) {
                  _context4.next = 11;
                  break;
                }

                return _context4.abrupt("return");

              case 11:
                if (!queryError) {
                  _context4.next = 14;
                  break;
                }

                this.run.errors.push(queryError);
                return _context4.abrupt("return");

              case 14:
                _context4.next = 16;
                return this.run.peersQueried.add(peer);

              case 16:
                if (!(res.pathComplete || res.queryComplete)) {
                  _context4.next = 19;
                  break;
                }

                this.path.res = res;
                return _context4.abrupt("return", {
                  pathComplete: res.pathComplete,
                  queryComplete: res.queryComplete
                });

              case 19:
                if (!(res.closerPeers && res.closerPeers.length > 0)) {
                  _context4.next = 22;
                  break;
                }

                _context4.next = 22;
                return Promise.all(res.closerPeers.map( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(closer) {
                    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            if (!_this3.dht._isSelf(closer.id)) {
                              _context3.next = 2;
                              break;
                            }

                            return _context3.abrupt("return");

                          case 2:
                            closer = _this3.dht.peerStore.put(closer);

                            _this3.dht._peerDiscovered(closer);

                            _context3.next = 6;
                            return _this3.path.addPeerToQuery(closer.id);

                          case 6:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  }));

                  return function (_x3) {
                    return _ref.apply(this, arguments);
                  };
                }()));

              case 22:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 6]]);
      }));

      function execQuery(_x2) {
        return _execQuery.apply(this, arguments);
      }

      return execQuery;
    }()
  }]);

  return WorkerQueue;
}();

module.exports = WorkerQueue;